module.exports = __webpack_public_path__ + "media/flags/ky-26f3373b.svg";